/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nichtsepaiban5Inputs */



/**

* @param {_Field_Nichtsepaiban5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_nichtsepaiban5 = /** @type {((inputs?: _Field_Nichtsepaiban5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nichtsepaiban5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nicht SEPA IBAN")
});
export { _field_nichtsepaiban5 as "_field_nichtSepaIBAN" }